
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 9.75L6 4.58a.52.52 0 01.13-.66A10.005 10.005 0 0112 2c.492.001.983.038 1.47.11a.501.501 0 01.35.74l-4 6.9a.501.501 0 01-.82 0zM12.87 9h8c.163 0 .316-.08.41-.213a.502.502 0 00.06-.457 10 10 0 00-5.25-5.46.49.49 0 00-.63.21l-3 5.17a.499.499 0 00.41.75zM5 5.86a.488.488 0 00-.386-.25.487.487 0 00-.424.18A9.906 9.906 0 002 12c.003.354.026.708.07 1.06a.49.49 0 00.5.44h6a.499.499 0 00.43-.75L5 5.86zM11.13 15h-8a.503.503 0 00-.41.213.502.502 0 00-.06.457A10.002 10.002 0 008 21.13a.49.49 0 00.63-.21l3-5.17a.499.499 0 00-.5-.75zM19 18.14c.08.143.224.237.386.25a.487.487 0 00.424-.18A9.906 9.906 0 0022 12a9.173 9.173 0 00-.07-1.06.49.49 0 00-.5-.44h-6a.499.499 0 00-.43.75l4 6.89zm-4.84-3.89l-4 6.9a.5.5 0 00.35.74 9.999 9.999 0 007.38-1.81.52.52 0 00.13-.66l-3-5.17a.5.5 0 00-.85 0h-.01z","fill-rule":"evenodd"}})])
          )
        }
      }
    